/* eslint-disable camelcase */
import React from 'react'
import { useTranslation } from 'react-i18next'
import Navbar from 'components/Navbar'
import { GeneralAccessibilityForm } from 'services'

const General = ({
  match: {
    params: { audit_id },
  },
}) => {
  const { t } = useTranslation('routes')

  return (
    <>
      <Navbar name={t('routes:audit.edit.generalAccessibility.name')} />
      <GeneralAccessibilityForm audit_id={audit_id} />
    </>
  )
}

export default General
